import "../SignupCL/SignupCL.css";
import { useNavigate } from "react-router-dom";
import { missingPopup } from "../../../helpers/dataHelper/missingData";
import { setLoading } from "../../../redux/loading/loadingSlice";
import { storeUser } from "../../../redux/users/usersSlice";
import { toastify } from "../../../helpers/toast/toastify";
import { useDispatch } from "react-redux";
import eye from "../../../assets/images/eye.svg";
import eyeBlock from "../../../assets/images/eye-block.svg";
import FloatingTextFiled from "../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import React, { useState } from "react";
import useApi from "../../../helpers/apiHelper/requestHelper";
import validator from "validator";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { fetchAdmin } from "../../../helpers/helper";

const ENV = window.location.hostname.split(".")[0] === "my" ? "prod" : "dev";

const PASSWORD_RULES = {
  DIGIT: /[0-9]/,
  MIN_LENGTH: 8,
  SPECIAL: /[!@#$%^&*()_+{}[\]:;<>,.?~-]/,
  UPPERCASE: /[A-Z]/,
};

const AdminLogin = () => {
  const api = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");

  const handlePasswordChange = (value) => {
    const newPassword = value;

    setData((prevState) => ({
      ...prevState,
      password: newPassword,
    }));

    if (!newPassword) {
      setValidationMessage("");
      return;
    }

    const validations = [
      {
        message: "Password must contain at least one digit",
        test: PASSWORD_RULES.DIGIT.test(newPassword),
      },
      {
        message: "Password must contain at least one special character",
        test: PASSWORD_RULES.SPECIAL.test(newPassword),
      },
      {
        message: "Password must contain at least one uppercase letter",
        test: PASSWORD_RULES.UPPERCASE.test(newPassword),
      },
      {
        message: `Password must be at least ${PASSWORD_RULES.MIN_LENGTH} characters long`,
        test: validator.isLength(newPassword, {
          min: PASSWORD_RULES.MIN_LENGTH,
        }),
      },
    ];

    const failedValidation = validations.find((v) => !v.test);
    setValidationMessage(failedValidation ? failedValidation.message : "");
  };

  const handleSignup = async () => {
    try {
      if (!data.email) return missingPopup("Email");
      if (!data.password) return missingPopup("Password");

      if (!/\S+@\S+\.\S+/.test(data.email))
        return toastify("Please enter a valid email address", "error");
      if (validationMessage) return toastify(validationMessage, "error");

      dispatch(setLoading(true));

      const response = await api("post", `superAdmin/loginAdmin`, data);

      if (response?.status) {
        localStorage.setItem("token", response?.data?.token);
        await fetchAdmin(api, dispatch, storeUser);
        setTimeout(() => {
          dispatch(setLoading(false));
          navigate(`/superadmin/dashboard`, { replace: true });
        }, 1500);
      } else {
        setTimeout(() => {
          dispatch(setLoading(false));
          toastify(response?.message);
        }, 1500);
      }
    } catch (error) {
      setTimeout(() => {
        dispatch(setLoading(false));
        toastify("catch ", error?.message);
      }, 1500);
    }
  };

  return (
    <div className="onboardinLayout">
      <div className="onboardingCard">
        <div className="onboardingCardTopBox">
          <p className="loginTop"></p>
        </div>
        <div className="onboardingCardContentBox">
          <div className="headingBox withHeight">
            <h2 className="title">Super Admin Login</h2>
            <p className="subText">Did you use your email to create a user?</p>
          </div>
          <div className="inputBox">
            <FloatingTextFiled
              className="onboardingInput"
              forLabel="Email"
              label="Email"
              onChange={(e) =>
                setData((pre) => ({ ...pre, email: e.target.value }))
              }
              placeholder="Email"
              type="email"
              value={data.email}
            />
          </div>
          <div className="inputBox password">
            <FloatingTextFiled
              className="onboardingInput"
              forLabel="Password"
              label="Password"
              onChange={(e) => {
                handlePasswordChange(e.target.value);
              }}
              placeholder="Password"
              type={showPassword ? "text" : "Password"}
              value={data.password}
            />
            <button
              className={`eyebtn ${showPassword && "view"}`}
              onClick={() => {
                setShowPassword((pre) => !pre);
              }}
              type="button"
            >
              <img alt="" src={showPassword ? eye : eyeBlock} />
            </button>
          </div>
          <BubbleSvgButton
            onClick={handleSignup}
            text="Log in"
            type="button"
            variant="green"
            containerStyling={{
              justifyContent: "center",
            }}
          />
          <div className="orBox">
            <p className="orText noBorder">
              Or did you sign up with a social account?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
